module.exports = __webpack_public_path__ + "img/unify@2x (1).a9d84215.png";